
import { NgModule } from '@angular/core';
import { Storage } from './storage.service';

@NgModule({
    providers: [Storage]
})
export class StorageModule {
}
